import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useUIStore = create(
  persist(
    (set, get) => ({
      // State
      isDarkMode: false,
      toasts: [],
      toastSeq: 0,

      // Actions
      toggleDarkMode: () => {
        const newMode = !get().isDarkMode;
        set({ isDarkMode: newMode });

        // Update document class for Tailwind dark mode
        if (newMode) {
          document.documentElement.classList.add("dark");
        } else {
          document.documentElement.classList.remove("dark");
        }
      },

      setDarkMode: (value) => {
        set({ isDarkMode: value });
        if (value) {
          document.documentElement.classList.add("dark");
        } else {
          document.documentElement.classList.remove("dark");
        }
      },

      // Toast helpers
      pushToast: (message, type = "info", duration = 2200, options = {}) => {
        const id = get().toastSeq + 1;
        const toast = {
          id,
          message,
          type,
          duration,
          // Optional action support and accessibility hints
          actionLabel: options.actionLabel,
          onAction: options.onAction,
          ariaLabel: options.ariaLabel,
          closable: options.closable !== false, // default true
        };
        set((state) => ({ toastSeq: id, toasts: [...state.toasts, toast] }));
        // Auto-remove after duration (if duration > 0)
        if (typeof duration === "number" && duration > 0) {
          setTimeout(() => {
            const current = get().toasts;
            const found = current.find((t) => t.id === id);
            if (!found) return;
            set({ toasts: current.filter((t) => t.id !== id) });
          }, duration);
        }
        return id;
      },
      removeToast: (id) => {
        set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }));
      },
      clearToasts: () => set({ toasts: [] }),

      // Initialize dark mode on app load
      initDarkMode: () => {
        const isDark = get().isDarkMode;
        if (isDark) {
          document.documentElement.classList.add("dark");
        } else {
          document.documentElement.classList.remove("dark");
        }
      },
    }),
    {
      name: "fex-ui-storage",
      partialize: (state) => ({ isDarkMode: state.isDarkMode }),
    }
  )
);
